import React from 'react';
import { Button, Form } from 'react-bootstrap';
import { statusRequiresInterviewDate } from '../../utils/candidateStatus';
import StatusSelect from './StatusSelect';

function StatusUpdatePanel({
  selectedStatus,
  onStatusChange,
  statusRemark,
  onRemarkChange,
  statusInterviewDate,
  onInterviewDateChange,
  onSubmit,
  saving = false,
  submitLabel = 'Update Status',
  layout = 'stacked',
}) {
  const panelClass = layout === 'inline'
    ? 'hr-candidate-status-panel d-flex flex-wrap align-items-end gap-2'
    : 'hr-candidate-status-panel';

  return (
    <div className={panelClass}>
      <div className="hr-candidate-status-field">
        <strong>Update Status</strong>
        <StatusSelect
          className="mt-1"
          value={selectedStatus || ''}
          onChange={onStatusChange}
        />
      </div>

      {statusRequiresInterviewDate(selectedStatus) && (
        <div className="hr-candidate-status-date">
          <strong>Interview Date</strong>
          <Form.Control
            type="date"
            value={statusInterviewDate || ''}
            onChange={onInterviewDateChange}
            required
          />
        </div>
      )}

      <div className="hr-candidate-status-field" style={{ minWidth: layout === 'inline' ? '220px' : '100%' }}>
        <strong>Remark *</strong>
        <Form.Control
          as="textarea"
          rows={2}
          value={statusRemark || ''}
          onChange={onRemarkChange}
          placeholder="Enter remark for this status update"
          required
        />
      </div>

      <Button
        variant="success"
        size="sm"
        disabled={saving}
        onClick={onSubmit}
      >
        {saving ? 'Updating...' : submitLabel}
      </Button>
    </div>
  );
}

export default StatusUpdatePanel;
